// ABOUTME: Banner warning bakers that forecasts are less accurate while a shop has little sales history.
// ABOUTME: Shown when the backend averages all past days because too few past days share the weekday.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@mui/material';

// Formats a "YYYY-MM-DD" date as e.g. "szeptember 28., hétfő" without timezone shifts
function formatLongDate(isoDate, language) {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(language, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

function LimitedHistoryBanner({ patternStatus }) {
  const { t, i18n } = useTranslation();

  if (patternStatus?.pattern_source !== 'all_days') return null;

  const variant = patternStatus.is_weekend ? 'weekend' : 'weekday';
  const values = {
    days: patternStatus.history_days,
    date: formatLongDate(patternStatus.day_of_week_pattern_from, i18n.language),
  };

  return (
    <Alert severity={patternStatus.is_weekend ? 'error' : 'warning'} sx={{ mb: 3 }}>
      <AlertTitle>{t(`dashboard.limitedHistory.${variant}Title`)}</AlertTitle>
      {t(`dashboard.limitedHistory.${variant}Text`, values)}
    </Alert>
  );
}

export default LimitedHistoryBanner;
